import { styled } from '@material-ui/core';
import { MaterialDesignContent } from 'notistack';

const DefaultNotistackContent = styled(MaterialDesignContent)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  boxShadow: '0px 2px 5px 0px rgb(0 0 0 / 20%);',
}));

export default DefaultNotistackContent;
